import React from 'react';
import Logo from '../assets/prana-logo.png';

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative flex items-center justify-center min-h-[90vh] px-6 md:px-12 py-16 overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('/images/hero-right.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-emerald-900/20"></div>

      {/* Decorative Blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-300 rounded-full opacity-20 blur-3xl -z-10"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-emerald-200 rounded-full opacity-20 blur-2xl -z-10"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl">

        {/* Logo */}
        <img
          src={Logo}
          alt="Prana Homoeopathic Clinic Logo"
          className="w-36 md:w-48 mb-6 drop-shadow-lg"
        />

        {/* Heading */}
        <h1 className="text-4xl md:text-6xl font-extrabold text-emerald-800 drop-shadow-lg leading-tight tracking-tight mb-6">
          Holistic Healing <br />
          Through Homeopathy
        </h1>

        {/* SEO Line */}
        <p className="text-lg md:text-2xl font-extrabold text-black drop-shadow-md mb-4 px-2">
          Trusted Homeopathy Clinic in Ranchi, Jharkhand
        </p>

        {/* Description */}
        <p className="text-base md:text-xl font-bold text-black drop-shadow-md max-w-3xl leading-relaxed mb-10 px-4">
          Reconnect with natural health and personalized care at{" "}
          <strong className="text-emerald-800">
            Prana Homoeopathic Clinic
          </strong>{" "}
          — where healing begins with compassion and nature under the guidance of{" "}
          <strong className="text-emerald-800">
            Dr. Sarita Kumari Singh.
          </strong>
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-5">

          {/* Book Appointment */}
          <a
            href="#contact"
            className="w-64 text-center px-6 py-4 bg-emerald-600 text-white rounded-full text-lg font-bold shadow-xl hover:bg-emerald-700 transition duration-300"
          >
            📅 Book Appointment
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/919631417625?text=Hello%20Prana%20Homoeopathic%20Clinic,%20I%20would%20like%20to%20book%20an%20appointment."
            target="_blank"
            rel="noopener noreferrer"
            className="w-64 text-center px-6 py-4 bg-green-500 text-white rounded-full text-lg font-bold shadow-xl hover:bg-green-600 transition duration-300"
          >
            💬 Chat on WhatsApp
          </a>

        </div>

      </div>
    </section>
  );
};

export default HeroSection;